<fui-rows *ngIf="item && formGroup" [formGroup]="formGroup" [hidden]="setToUndefined">
    <fui-row label="wbo.screen-layout.edit.field-set.item-properties">
        <fui-rows>
            <fui-row>
                <wbo-single-select-edit-control [(ngModel)]="itemType"
                                                [allowClearSelectionOption]="false"
                                                [readonly]="itemTypeReadonly"
                                                formControlName="itemType">
                    <wbo-select-options>
                        <wbo-select-option [label]="'wbo.screen-layout.edit.option.itemType.subMenu'"
                                           [value]="ITEM_TYPE.SUB_MENU"></wbo-select-option>
                        <wbo-select-option [label]="'wbo.screen-layout.edit.option.itemType.sellable'"
                                           [value]="ITEM_TYPE.SELLABLE"></wbo-select-option>
                        <wbo-select-option [label]="'wbo.screen-layout.edit.option.itemType.extra'"
                                           [value]="ITEM_TYPE.EXTRA"></wbo-select-option>
                        <wbo-select-option [label]="'wbo.screen-layout.edit.option.itemType.preparationModifier'"
                                           [value]="ITEM_TYPE.PREP"></wbo-select-option>
                        <wbo-select-option [label]="'wbo.screen-layout.edit.option.itemType.size'"
                                           [value]="ITEM_TYPE.SIZE"></wbo-select-option>
                        <wbo-select-option [label]="'wbo.screen-layout.edit.option.itemType.customFunction'"
                                           [value]="ITEM_TYPE.CUSTOM_FUNCTION"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-edit-control>
            </fui-row>
            <fui-row>
                <fui-column>
                    <wbo-text-edit-control [(ngModel)]="identifier"
                                           [hidden]="true"
                                           formControlName="identifier"></wbo-text-edit-control>
                    <wbo-sellable-single-select-edit-control (onSelect)="changeSellable($event)"
                                                             *ngIf="itemType === ITEM_TYPE.SELLABLE"
                                                             [(ngModel)]="identifier"
                                                             [allowClearSelectionOption]="false"
                                                             [label]="'wbo.screen-layout.edit.field.configCategories.touchItems.sellableId.label'"
                                                             formControlName="identifier"
                                                             [placeholder]="'wbo.screen-layout.edit.field.configCategories.touchItems.sellableId.placeholder'">
                    </wbo-sellable-single-select-edit-control>
                    <wbo-product-line-single-select-edit-control (onSelect)="changeExtra($event)"
                                                                 *ngIf="itemType === ITEM_TYPE.EXTRA"
                                                                 [(ngModel)]="identifier"
                                                                 [allowClearSelectionOption]="false"
                                                                 [label]="'wbo.screen-layout.edit.field.configCategories.touchItems.sellableExtraId.label'"
                                                                 [placeholder]="'wbo.screen-layout.edit.field.configCategories.touchItems.sellableExtraId.placeholder'"
                                                                 formControlName="identifier">
                    </wbo-product-line-single-select-edit-control>
                    <wbo-product-modifier-values-single-select-edit-control
                        (onSelect)="changePreparationModifier($event)"
                        *ngIf="itemType === ITEM_TYPE.PREP"
                        [(ngModel)]="identifier"
                        [allowClearSelectionOption]="false"
                        [label]="'wbo.screen-layout.edit.field.configCategories.touchItems.preparationModifierId.label'"
                        [placeholder]="'wbo.screen-layout.edit.field.configCategories.touchItems.preparationModifierId.placeholder'"
                        [type]="MetaTagType.PREPARATION"
                        formControlName="identifier">
                    </wbo-product-modifier-values-single-select-edit-control>
                    <wbo-size-group-values-single-select-edit-control (onSelect)="changeSize($event)"
                                                                      *ngIf="itemType === ITEM_TYPE.SIZE"
                                                                      [allowClearSelectionOption]="false"
                                                                      [(ngModel)]="identifier"
                                                                      formControlName="identifier"
                                                                      [label]="'wbo.screen-layout.edit.field.configCategories.touchItems.sizeId.label'"
                                                                      [placeholder]="'wbo.screen-layout.edit.field.configCategories.touchItems.sizeId.placeholder'">
                    </wbo-size-group-values-single-select-edit-control>
                    <wbo-single-select-edit-control *ngIf="itemType === ITEM_TYPE.CUSTOM_FUNCTION"
                                                    [(ngModel)]="identifier"
                                                    (onSelect)="changeFunction($event)"
                                                    [allowClearSelectionOption]="false"
                                                    [label]="'wbo.screen-layout.edit.field.configCategories.touchItems.functionId.label'"
                                                    [placeholder]="'wbo.screen-layout.edit.field.configCategories.touchItems.functionId.placeholder'"
                                                    formControlName="identifier">
                        <wbo-select-options>
                            <wbo-select-option [label]="'wbo.screen-layout.edit.option.customFunction.addModifier'"
                                               [value]="0"></wbo-select-option>
                            <wbo-select-option
                                [label]="'wbo.screen-layout.edit.option.customFunction.refundProduct'"
                                [value]="1"></wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                </fui-column>
            </fui-row>
            <fui-row>
                <fui-column>
                    <wbo-textarea-edit-control [(ngModel)]="displayName"
                                               formControlName="displayName">
                    </wbo-textarea-edit-control>
                </fui-column>
            </fui-row>
            <fui-row *ngIf="itemType === ITEM_TYPE.SUB_MENU">
                <fui-column>
                    <wbo-course-single-select-edit-control [(ngModel)]="courseId"
                                                           [courseDefinitionId]="courseDefinitionId"
                                                           [readonly]="!courseDefinitionId"
                                                           formControlName="courseId">
                    </wbo-course-single-select-edit-control>
                </fui-column>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-color-edit-control [(ngModel)]="colour"
                                                formControlName="colour">
                        </wbo-color-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-color-edit-control [(ngModel)]="foreColour"
                                                formControlName="foreColour">
                        </wbo-color-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-three-columns>
                    <fui-column>
                        <wbo-font-single-select-edit-control [(ngModel)]="item.fontName"
                                                             formControlName="fontName">
                        </wbo-font-single-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-font-style-single-select-edit-control [(ngModel)]="item.fontStyle"
                                                                   formControlName="fontStyle">
                        </wbo-font-style-single-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-font-size-single-select-edit-control [(ngModel)]="item.fontSize"
                                                                  formControlName="fontSize">
                        </wbo-font-size-single-select-edit-control>
                    </fui-column>
                </fui-three-columns>
            </fui-row>
            <fui-row *ngIf="showExtraRules">
                <fui-column>
                    <wbo-size-group-single-select-edit-control [(ngModel)]="sellableSizeGroup"
                                                               formControlName="sellableSizeGroup">
                    </wbo-size-group-single-select-edit-control>
                </fui-column>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column *ngIf="showExtraRules">
                        <wbo-checkbox-edit-control [(ngModel)]="applyExtraRules"
                                                   formControlName="applyExtraRules">
                        </wbo-checkbox-edit-control>
                    </fui-column>
                    <fui-column *ngIf="showPopup">
                        <wbo-single-select-edit-control [(ngModel)]="popup" clearSelectionOptionLabel="wbo.common.option.boolean.default"
                                                        formControlName="popup">
                            <wbo-boolean-select-options></wbo-boolean-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-row>
    <fui-row *ngIf="!(editService.$entityRestricted | async)">
        <div class="toolBar">
            <fui-pop-button (click)="model.removeItem(item)"
                            [title]="'wbo.screen-layout.edit.action.touchItem.remove'"></fui-pop-button>
            <fui-pop-button (click)="model.clearItem(item)"
                            [title]="'wbo.screen-layout.edit.action.touchItem.clear'"></fui-pop-button>
        </div>
    </fui-row>
</fui-rows>
